import { useEffect } from 'react';

import { useStartAPetitionPageState } from 'src/app/pages/startAPetitionV2/pageContext';
import { useCurrentAuthenticatedUser } from 'src/app/shared/hooks/session';

import { useTrackSuccessfulLoginOrJoin } from './useTrackSuccessfulLoginOrJoin';

export function useTrackLoginOrJoinMethod(): void {
	const user = useCurrentAuthenticatedUser(); // why are we treating IDENTIFIED users as if they are GUEST?
	const { data } = useStartAPetitionPageState();
	const { loginOrJoinMethod } = data.draft?.metadata?.user || {};
	const { trackSuccessfulLoginOrJoin } = useTrackSuccessfulLoginOrJoin();

	useEffect(() => {
		if (loginOrJoinMethod === 'email_verify') {
			void trackSuccessfulLoginOrJoin({
				email: user?.email,
				userId: user?.id,
				newUser: true,
				loginMethod: 'email',
				loginOrJoinMethod: 'email_verify',
				loginType: 'email_signup',
				userFlow: 'future_sap',
			});
		}
	}, [loginOrJoinMethod, trackSuccessfulLoginOrJoin, user?.email, user?.id]);
}
